import { toast } from "react-toastify";

export const notify = (msg, type) => {
  if (type === "warn") toast.warn(msg);
  else if (type === "success") toast.success(msg);
  else if (type === "error") toast.error(msg);
};

export const validateLogin = ({ email, password, t }) => {
  // فحص الإيميل
  if (!email || email.trim() === "") {
    notify(t("utils.validate.email_required"), "warn");
    return false;
  }

  // صيغة الإيميل
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    notify(t("utils.validate.email_invalid"), "warn");
    return false;
  }

  // فحص كلمة المرور
  if (!password || password.length < 6) {
    notify(t("utils.validate.password_length"), "warn");
    return false;
  }

  return true;
};

export const validateSpecialty = (specialty) => {
  return (
    typeof specialty === "string" &&
    specialty.trim().length > 2 &&
    /^[a-zA-Z\s]+$/.test(specialty.trim())
  );
};
